import React from 'react';
import {
    Card,
    Typography,
    Box,
    Avatar,
    useTheme,
    useMediaQuery
} from '@mui/material';

import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import { FaUserTie } from "react-icons/fa";

import { ReportDescription } from '../../../WorkSites/Schedule/ScheduleDetails/Components/ReportDescription/ReportDescription';
const InfoItem = ({ icon, label, value, color }) => {

    return (
        <Box
            display="flex"
            alignItems="center"
            gap={2}
            borderRadius={3}

        >
            <Avatar
                sx={{
                    bgcolor: color || 'primary.main',
                    width: 44,
                    height: 44,
                }}
            >
                {icon}
            </Avatar>
            <Box>
                <Typography variant="caption" color="text.secondary">
                    {label}
                </Typography>
                <Typography
                    variant="subtitle1"
                    fontWeight={600}
                    sx={{ wordBreak: 'break-word' }}
                >
                    {value ?? 'N/A'}
                </Typography>
            </Box>
        </Box>
    );
};

const InvoiceInfo = ({ invoiceData = {}, ClientName }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const { amount, invoiceDate, PaymentDescription, invoiceNumber, PaymentStatusName, description } = invoiceData;

    return (
        <Card
            sx={{
                maxWidth: 800,
                margin: '24px auto',
                borderRadius: 4,
                backgroundColor: '#ffffff',
                boxShadow: '0 6px 20px rgba(0,0,0,0.06)',
                px: isMobile ? 2 : 4,
                py: 3,
            }}
        >
            <Typography
                variant="h6"
                fontWeight={700}
                textAlign="center"
                color='rgb(17 24 39)'
                mb={3}
            >
                {invoiceNumber}
            </Typography>

            <div style={{ display: 'flex', justifyContent: 'space-between' }}>

                <InfoItem
                    icon={<CalendarTodayIcon />}
                    label="Invoice Date"
                    value={invoiceDate}
                    color="info.main"
                />

                <InfoItem
                    icon={`AED`}
                    label="Amount"
                    value={amount}
                    color="success.main"
                />
               

                <InfoItem
                    icon={<AssuredWorkloadIcon />}
                    label="Status"
                    value={PaymentStatusName}
                    color="warning.main"
                />
            </div>
            <div className='mt-4'>
                 <InfoItem
                    icon={<FaUserTie />}
                    label="Client Name"
                    value={ClientName[0]}
                    color="secondary.main"  
                />
                <ReportDescription title={`Invoice Description`} description={description || `N/A`} />
                <ReportDescription title={`Payment Description`} description={PaymentDescription || `N/A`} />
            </div>
        </Card>
    );
};

export default InvoiceInfo;
